import { getAPI, patchAPI } from "utils/http";
import { apis } from "config/urls";

export async function getRolesAndProducts({ userId, userIdSub, userType, isUserUpdatedPostEdit, token }) {
  const encodedUserId = btoa(userIdSub);
  const products =
    userType === 3 || isUserUpdatedPostEdit
      ? getAPI(apis.usersAPI + `/users_sst_product/${userId}`, {}, token)
      : undefined;
  const roles = getAPI(apis.externalRolesAPI, {}, token);
  const userRoles = getAPI(
    apis.userManagementAPI + `users/${encodedUserId}/roles`,
    {},
    token
  );
  const results = await Promise.allSettled([products, roles, userRoles]);
  return {
    assignedProducts:
      results[0].status === "fulfilled" ? results[0].value : null,
    availableRoles: results[1].status === "fulfilled" ? results[1].value : null,
    assignedRoles: results[2].status === "fulfilled" ? results[2].value : null,
    errors: results
      .map((r, i) =>
        r.status === "rejected" ? { index: i, reason: r.reason } : null
      )
      .filter(Boolean),
  };
}

export async function getUserAssignedPermissions({ userId, token }) {
  const encodedUserId = btoa(userId);
  return await getAPI(
    apis.userManagementAPI + `users/${encodedUserId}/permissions`,
    { page: 0, size: 1000 },
    token
  );
}

export async function getSSTProducts({ userId, token }) {
  return getAPI(apis.usersAPI + `/users_sst_product/${userId}`, {}, token);
}

export async function editUser({ userId, token, formData }) {
  return await patchAPI(
    apis.userManagementAPIGlasswall + `/users/edit/${userId}`,
    { ...formData },
    token
  );
}
